import { Component } from '@angular/core';

@Component({
  selector: 'app-standard-header-layout',
  templateUrl: './standard-header-layout.component.html',
  styleUrl: './standard-header-layout.component.scss'
})
export class StandardHeaderLayoutComponent {

}
